export const allViews = ['Tracker', 'InfoGraphics', 'Test Centres', 'Resources'];
